"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _toConsumableArray2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
var _shop = require("@/api/shop");
var _setmeal = require("@/api/iot/setmeal");
var _default = {
  props: ['id'],
  data: function data() {
    return {
      loading: false,
      selectLoading: false,
      infoData: {
        id: 0,
        deposit: 0,
        invite_type: 0,
        invite_amount: 0,
        invite_coupon_id: 0,
        invite_coupon_num: 0
      },
      options: [{
        value: 0,
        label: '无'
      }, {
        value: 1,
        label: '返优惠券'
      }, {
        value: 2,
        label: '返现'
      }],
      couponList: [],
      defaultCouponList: [{
        id: 0,
        name: '无'
      }],
      value: 0
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      this.getSelectCouponList();
      this.getData();
    },
    getData: function getData() {
      var _this = this;
      this.loading = true;
      (0, _shop.shopBaseInfo)().then(function (res) {
        _this.loading = false;
        if (res) {
          for (var key in _this.infoData) {
            _this.infoData[key] = res[key];
          }
        }
      });
    },
    remoteMethod: function remoteMethod() {
      var _this2 = this;
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.$func.debounce(function () {
        // console.log('remoteMethod', query)
        if (query === '') {
          _this2.couponList = (0, _toConsumableArray2.default)(_this2.defaultCouponList);
        } else {
          _this2.selectLoading = true;
          _this2.getSelectCouponList(query);
        }
      });
    },
    getSelectCouponList: function () {
      var _getSelectCouponList = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var search,
          param,
          res,
          _this$defaultCouponLi,
          _args = arguments;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                search = _args.length > 0 && _args[0] !== undefined ? _args[0] : '';
                param = {
                  name: search,
                  status: 1
                };
                _context.next = 4;
                return (0, _setmeal.getCouponList)(param).catch(function () {});
              case 4:
                res = _context.sent;
                // console.log('getSelectCouponList', res)
                this.selectLoading = false;
                if (res.data) {
                  if (search == '') {
                    (_this$defaultCouponLi = this.defaultCouponList).push.apply(_this$defaultCouponLi, (0, _toConsumableArray2.default)(res.data));
                    this.couponList = (0, _toConsumableArray2.default)(this.defaultCouponList);
                  } else {
                    this.couponList = (0, _toConsumableArray2.default)(res.data);
                  }
                }
              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getSelectCouponList() {
        return _getSelectCouponList.apply(this, arguments);
      }
      return getSelectCouponList;
    }(),
    chkCouponId: function chkCouponId() {
      if (this.infoData.coupon_id == 0) {
        this.infoData.coupon_num = 0;
      }
    },
    submit: function submit() {
      var _this3 = this;
      console.log('submit', this.infoData);
      var param = {
        form_data: (0, _objectSpread2.default)({}, this.infoData)
      };
      (0, _shop.editShopConfig)(param).then(function (res) {
        _this3.getData();
      });
    }
  }
};
exports.default = _default;